/** @file Throws the VALIDATION error for one field: what was expected, what was found, where. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import { throwError } from '@zilo/pose3d-std/errors/throwError';

function describe(value: unknown): string {
  if (value === null) return 'null';
  if (Array.isArray(value)) return `array(${value.length})`;
  if (typeof value === 'number' || typeof value === 'boolean') return `${typeof value} ${String(value)}`;
  if (typeof value === 'string') return `string ${JSON.stringify(value.slice(0, 40))}`;
  return typeof value;
}

/** Throws `VALIDATION` at `path` (JSON pointer; '' is the document) with `{ expected, got }`. */
export function failField(path: string, expected: string, value: unknown, hint?: string): never {
  const ctx = hint === undefined ? { path: path || '/' } : { path: path || '/', hint };
  return throwError(ERROR_CODES.VALIDATION, { expected, got: describe(value) }, ctx);
}
